
// 用户页
const personalCenter = () => import(/* webpackChunkName: "Index" */ '@/views/personalCenter/index')

const personalCenterRouter = [
    {
      path: '/index',
      redirect: '/admin/home',
      component: () => import('@/views/loginModule/index'),
      children: [
        {
          path: '/admin/personalCenter',
          name: 'personalCenter',
          component: personalCenter,
          meta: {
            title: '个人中心'
          }
        }
      ]
    }
  ]
  export default personalCenterRouter
  
